import { Box, Container } from '@mui/material'
import { Loader, useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useYardStores } from '../../AppProvider'
import { AllocationRulesTemplateHeader } from './components/molecules/AllocationRulesTemplateHeader'
import { AllocationRulesTemplateTable } from './components/organisms/AllocationRulesTemplateTable'

export const AllocationRulesTemplatePage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { allocationRuleStore, yardBlockStore } = useYardStores()

    const { loading } = useAsyncFetch(async () => {
      await Promise.all([allocationRuleStore.loadTemplateRules(), yardBlockStore.loadYardBlocks()])
    }, [allocationRuleStore, yardBlockStore])

    if (loading) return <Loader show />

    return (
      <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100%' }}>
        <AllocationRulesTemplateHeader />
        <Container
          sx={{ paddingY: theme.customSpacing.m }}
          data-cy='allocation-rules-template-table'
        >
          <AllocationRulesTemplateTable store={allocationRuleStore} />
        </Container>
      </Box>
    )
  }),
)
